let css = require('./content.css');
let Order = require('../../order');
let BitrixMain = require('../../bitrixMain');
let Account = require('../../account');
let Contacts = require('../../contacts');
let Help = require('../../help');
let Terms = require('../../terms');
let Overlay = require('../overlay');
let Video = require('../../video');
let Statistic = require('../../account/statistic');

class Content {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: Content,
    children: [
        {
            name: 'bitrix-main',
            component: BitrixMain
        },
        {
            name: 'order',
            component: Order
        },
        {
            name: 'account',
            component: Account,
            watcher: {
                isManager: ['user', 'isManager'],
                ordersTabIsSelected: ['subnavigation', 'elements', 0, 'isSelected']
            }
        },
        {
            name: 'personal',
            component: require('../../personal'),
            watcher: {
                isBitrix: ['bitrix', 'isBitrix']
            }
        },
        {
            name: 'contacts',
            component: Contacts
        },
        {
            name: 'help',
            component: Help,
            watcher: {
                onlinePaymentPriceLimit: ['data', 'onlinePaymentPriceLimit'],
                basicColumns: ['data', 'computed', 'columns', 'basic'],
                optionalColumns: ['data', 'computed', 'columns', 'optional'],
                isBitrix: ['bitrix', 'isBitrix'],
                role: ['user', 'role']
            }
        },
        {
            name: 'terms',
            component: Terms
        },
        {
            name: 'video',
            component: Video
        },
        {
            name: 'overlay',
            component: Overlay,
            watcher: {
                isLoading: ['isLoading']
            }
        },
        {
            name: 'statistic',
            component: Statistic
        }
    ]
};



// WEBPACK FOOTER //
// ./components/layout/content/index.js